import React, { useEffect, useState } from 'react';
import { Phone, Menu, X, ShoppingBag } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: t('nav.inicio'),
    href: '#inicio'
  }, {
    name: t('nav.problema'),
    href: '#problema'
  }, {
    name: t('nav.sistema'),
    href: '#sistema'
  }, {
    name: t('nav.trabajos'),
    href: '#trabajos'
  }, {
    name: t('nav.nosotros'),
    href: '#nosotros'
  }, {
    name: t('nav.garantia'),
    href: '#garantia'
  }, {
    name: t('nav.faq'),
    href: '#faq'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-black/95 backdrop-blur-md py-3 shadow-lg' : 'bg-brand-black py-5'}`} data-id="element-153">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-154">
        <div className="flex justify-between items-center" data-id="element-155">
          {/* Logo */}
          <a href="#inicio" className="flex items-center gap-3 group" data-id="element-156">
            <div className="h-12 w-12 sm:h-14 sm:w-14 rounded overflow-hidden bg-black flex-shrink-0" data-id="element-157">
              <img src="https://cdn.magicpatterns.com/uploads/iYwSJn6f4bZdGuVT15Hcgi/logo.jpg" alt="JOM Elite Construction LLC Logo" className="h-full w-full object-cover" data-id="element-158" />
            </div>
            <div className="hidden sm:block" data-id="element-159">
              <span className="block text-brand-gold font-serif font-bold text-xl leading-none tracking-wide group-hover:text-brand-goldLight transition-colors" data-id="element-160">
                JOM ELITE
              </span>
              <span className="block text-white/80 text-xs tracking-widest mt-1" data-id="element-161">
                CONSTRUCTION LLC
              </span>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-162">
            <ul className="flex gap-6" data-id="element-163">
              {navLinks.map(link => <li key={link.name} data-id="element-164">
                  <a href={link.href} className="text-white/80 hover:text-brand-gold text-sm font-medium transition-colors" data-id="element-165">
                    {link.name}
                  </a>
                </li>)}
            </ul>

            <div className="flex items-center gap-4 border-l border-white/20 pl-6" data-id="element-166">
              <div className="flex items-center gap-2 bg-white/5 rounded-full p-1 border border-white/10" data-id="element-167">
                <button onClick={() => setLang('es')} className={`px-3 py-1 rounded-full text-xs font-bold transition-colors ${lang === 'es' ? 'bg-brand-gold text-brand-black' : 'text-white/60 hover:text-white'}`} data-id="element-168">
                  ES
                </button>
                <button onClick={() => setLang('en')} className={`px-3 py-1 rounded-full text-xs font-bold transition-colors ${lang === 'en' ? 'bg-brand-gold text-brand-black' : 'text-white/60 hover:text-white'}`} data-id="element-169">
                  EN
                </button>
              </div>

              <a href="https://www.jomelitesupply.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-white/80 hover:text-brand-gold text-sm font-medium transition-colors border border-white/20 hover:border-brand-gold/60 px-3 py-2 rounded" data-id="element-170">
                <ShoppingBag className="w-4 h-4" data-id="element-171" />
                <span data-id="element-172">{t('nav.tienda')}</span>
              </a>
              <a href="tel:8137534656" className="flex items-center gap-2 bg-brand-gold hover:bg-brand-goldLight text-brand-black px-5 py-2.5 rounded font-semibold transition-colors" data-id="element-173">
                <Phone className="w-4 h-4" data-id="element-174" />
                <span data-id="element-175">{t('nav.cotizacion')}</span>
              </a>
            </div>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-176">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-177" /> : <Menu className="w-6 h-6" data-id="element-178" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-brand-black border-t border-white/10 shadow-xl" data-id="element-179">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-180">
            <div className="flex items-center justify-center gap-2 mb-4 mt-2 bg-white/5 rounded-full p-1 border border-white/10 w-max mx-auto" data-id="element-181">
              <button onClick={() => {
            setLang('es');
            setMobileMenuOpen(false);
          }} className={`px-4 py-1.5 rounded-full text-sm font-bold transition-colors ${lang === 'es' ? 'bg-brand-gold text-brand-black' : 'text-white/60'}`} data-id="element-182">
                Español
              </button>
              <button onClick={() => {
            setLang('en');
            setMobileMenuOpen(false);
          }} className={`px-4 py-1.5 rounded-full text-sm font-bold transition-colors ${lang === 'en' ? 'bg-brand-gold text-brand-black' : 'text-white/60'}`} data-id="element-183">
                English
              </button>
            </div>
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-white/80 hover:text-brand-gold hover:bg-white/5 rounded-md" data-id="element-184">
                {link.name}
              </a>)}
            <a href="https://www.jomelitesupply.com/" target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-2 px-3 py-3 text-base font-medium text-white/80 hover:text-brand-gold hover:bg-white/5 rounded-md" data-id="element-185">
              <ShoppingBag className="w-5 h-5" data-id="element-186" />
              <span data-id="element-187">{t('nav.tiendaOnline')}</span>
            </a>
            <div className="mt-4 px-3" data-id="element-188">
              <a href="tel:8137534656" className="flex items-center justify-center gap-2 w-full bg-brand-gold text-brand-black px-5 py-3 rounded font-semibold" data-id="element-189">
                <Phone className="w-5 h-5" data-id="element-190" />
                <span data-id="element-191">{t('nav.llamar')}</span>
              </a>
            </div>
          </div>
        </div>}
    </header>;
}